import { Component, OnInit } from '@angular/core';
import { listType } from 'src/app/core/enumerations/enum-ListType';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';
import { PaginationModel } from 'src/app/core/models/pagination-model';
import { payRequestModel } from 'src/app/core/models/payRequestModel';
import * as html2pdf from 'html2pdf.js'

@Component({
  selector: 'app-legal-circulars',
  templateUrl: './legal-circulars.component.html',
  styleUrls: ['./legal-circulars.component.scss']
})
export class LegalCircularsComponent implements OnInit {
    paginationModel: PaginationModel;
  payRequestModel: payRequestModel;
  loggedInUser: any;
  selectedSort: any;
  Records: any;
  totalRecords: any;
  totalPages: number;
  pages = new Array();
  PageNo: number = 0;
  PN: number;
  ID: number = 0;
  Sector: any;
  DropdownRecords: any
  selectedValue: any
  isSelected: boolean;
  selectedStateID: any;
  ClosingDate: any;
  TenderNumber: any;
  searchTerm: any;


  constructor(public userUtilsService: UserUtilService, private service: PublicPortalService, private portalService: PublicPortalService,) { }

  ngOnInit(): void {
    this.paginationModel = new PaginationModel();
    this.payRequestModel = new payRequestModel();
    this.PageNo = Number(this.paginationModel.pageNumber);
    this.GetPayDetailList();
  }
  GetPayDetailList() {
    this.payRequestModel.Type = listType.Legal;
    this.payRequestModel.ID = 0;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize = "100"
    this.service.getlegalcircularsinfo(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.totalPages = data?.totalPages;
              this.totalRecords = data?.totalRecords;
              this.pages = new Array();
              for (let i = 1; i <= this.totalPages; i++) {
                this.pages.push(i);
              }
              this.Records = data?.records;
            }
          }
        }
      })
  }
  public getPDF() {
    var element = document.getElementById('pprclause');
    html2pdf(element);
  }
  ClearSearch() {
    this.searchTerm = ''
  }

  print() {

    window.print()
    // //let myWindow = window.open('', 'my div', 'height=400,width=600');
    // var element = document.getElementById('pprclause'); 
    // let html = "";
    // html = element.innerHTML
    // const printWindow = window.open('', '_blank');
    // if (printWindow) {
    //   printWindow.document.write(html);
    // }
    // printWindow.print();
    // myWindow.close();
  }
}
